import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { EntityDataDispatcher } from '../entity-data/entity-data.dispatcher';
import { GlobalBannerService } from '../shared/components/global-banner/global-banner.service';
import { TrackedTime } from './models/tracked-time.model';
import {
  billTrackedTime,
  clearDraftTrackedTime,
  newDraftTrackedTime,
  setDraftTrackedTime,
} from './tracked-time-data.actions';
import { TrackedTimeDataBuilder } from './tracked-time-data.builder';
import { IState } from './tracked-time-data.reducer';
import { TrackedTimeDataStore } from './tracked-time-data.store';

@Injectable()
export class TrackedTimeDataDispatcher extends EntityDataDispatcher<
  IState,
  TrackedTime
> {
  constructor(
    store: Store<any>,
    trackedTimeDataStore: TrackedTimeDataStore,
    trackedTimeDataBuilder: TrackedTimeDataBuilder,
    globalBannerService: GlobalBannerService,
    translateService: TranslateService
  ) {
    super(
      store,
      trackedTimeDataStore,
      trackedTimeDataBuilder,
      globalBannerService,
      translateService
    );
  }

  newDraftTrackedTime() {
    this.store.dispatch(newDraftTrackedTime(this.entityType));
  }

  setDraftTrackedTime(trackedTime: TrackedTime) {
    this.store.dispatch(setDraftTrackedTime(this.entityType, trackedTime));
  }

  clearDraftTrackedTime() {
    this.store.dispatch(clearDraftTrackedTime(this.entityType));
  }

  billTrackedTime(trackedTimeId: string, clientReferenceId: string) {
    this.store.dispatch(
      billTrackedTime(this.entityType, trackedTimeId, clientReferenceId)
    );
  }
}
